import React, { useEffect, useState } from "react";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { toFixedWithoutRounding } from "../../Utils/Constant";

export default function BookPosition({ isOpen, object, onClose, runPosition = false }) {
  const [detailsData, setDetailsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (
      !isOpen ||
      !object?.eventId ||
      (!runPosition && !object?.marketId) ||
      !object?.selectionId
    ) {
      return;
    }
    const controller = new AbortController();
    setDetailsData([]);
    setError("");
    setLoading(true);
    apiGet(runPosition ? apiPath.fancyPositionAdmin : apiPath.fancyPosition, {
      eventId: object.eventId,
      selectionId: object.selectionId,
      ...(!runPosition ? { marketId: object.marketId } : {}),
    }, { signal: controller.signal }).then(({ status, data }) => {
      if (controller.signal.aborted) return;
      if (status !== 200 || !data.success) throw new Error(data.message || "Unable to load book position.");
      const rows = Array.isArray(data.results) ? data.results : data.results?.bets || [];
      setDetailsData([...rows].sort((a, b) => a.betRun - b.betRun));
    }).catch((failure) => {
      if (!controller.signal.aborted) setError(failure.message || "Unable to load book position.");
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [isOpen, object?.eventId, object?.marketId, object?.selectionId, runPosition]);

  if (!isOpen) return null;

  return (
    <div className="risk-inner-scope">
      <div
        id="createModal"
        className="pop_bg"
        style={{ height: "100%", width: "100%", display: "block" }}
        onClick={() => onClose?.()}
      >
        <div className="pop-content" onClick={(e) => e.stopPropagation()}>
          <div
            id="logWrap"
            className="log-wrap"
            style={{ marginTop: "9vh", width: "600px", overflow: "auto" }}
          >
            <table className="game-team table-responsive">
              <tbody>
                <tr>
                  <td className="game-name">
                    <div className="wd">{object?.fancyName}</div>
                    <a
                      onClick={() => onClose?.()}
                      style={{ display: "block", cursor: "pointer" }}
                      className="pop-close"
                    >
                      <img
                        src="data:image/gif;base64,R0lGODdhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
                        className="icon-back"
                      />
                      Close
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="pop-content">
              <table id="table" className="table01 tab-depth table-responsive">
                <tbody>
                  <tr>
                    <th width="50%" className="align-L">
                      Runs
                    </th>
                    <th width="50%" className="border-l">
                      Amount
                    </th>
                  </tr>

                  {detailsData.length > 0 ? (
                    detailsData.map((res, index) => (
                      <tr key={index}>
                        <td
                          className="align-L"
                          style={
                            res.position >= 0
                              ? { background: "rgba(147, 197, 253, 1)" }
                              : { background: "rgba(252, 165, 165, 1)" }
                          }
                        >
                          {res.betRun}
                        </td>
                        <td
                          style={
                            res.position >= 0
                              ? { background: "rgba(147, 197, 253, 1)" }
                              : { background: "rgba(252, 165, 165, 1)" }
                          }
                        >
                          {res.position >= 0
                            ? toFixedWithoutRounding(res.position)
                            : `(${toFixedWithoutRounding(res.position)})`}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2}>{loading ? "Loading book position…" : error || "No records found"}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
